import es from "./es.json";
import fr from "./fr.json";
import pt from "./pt.json";

export default {
  es,
  fr,
  pt
};
